module.exports = __webpack_public_path__ + "img/hw-s2.08b85618.svg";